import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import { AddNewEventComponent } from './add-new-event.component';


@NgModule({
  declarations: [AddNewEventComponent],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
  ],
})
export class AddNewEventModule {
}